module.exports = __webpack_public_path__ + "images/pro/img-pro-zoom@2x-9e9706a394832d2131f883dd43654016.jpg";